"use client";

import { motion } from "framer-motion";

export default function CommonHero({
  badge,
  title,
  highlight,
  description,
  children,
}) {
  return (
    <section className="relative pt-24 sm:pt-28 lg:pt-32 pb-14 sm:pb-16 lg:pb-20 overflow-hidden bg-[#fafafa]">

      {/* Background */}

      <div className="relative w-full mx-auto max-w-[900px] sm:max-w-[1100px] lg:max-w-[1300px] xl:max-w-[1500px] 2xl:max-w-[1700px] 3xl:max-w-[1900px] px-4 sm:px-6 lg:px-10">

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-left md:text-center max-w-4xl md:mx-auto"
        >

          {/* Badge */}
          {badge && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center px-5 py-2 rounded-full bg-[#B8893A] shadow-md mb-5 sm:mb-6"
            >
              <span className="text-white font-semibold text-xs sm:text-sm uppercase tracking-wider">
                {badge}
              </span>
            </motion.div>
          )}

          {/* Title */}
          <h1 
            className="font-[700] text-[#000000] mb-4 sm:mb-6"
            style={{ 
              fontSize: "clamp(28px, 5vw, 48px)",
              lineHeight: "1.3"
            }}
          >
            {title}
            {highlight && (
              <span 
                className="block text-[#B8893A] mt-2 font-bold uppercase tracking-widest"
                style={{ fontSize: "clamp(14px, 1.2vw, 16px)" }}
              >
                {highlight}
              </span>
            )}
          </h1>

          {/* Description */}
          <p 
            className="text-gray-600 max-w-2xl sm:max-w-3xl md:mx-auto mb-8 sm:mb-10"
            style={{ 
              fontSize: "clamp(14px, 1.2vw, 16px)",
              lineHeight: "1.6"
            }}
          >
            {description}
          </p>

          {/* Buttons / Children */}
          {children && (
            <div className="flex flex-col sm:flex-row gap-4 justify-start md:justify-center items-start md:items-center">
              {children}
            </div>
          )}

        </motion.div>
      </div>
    </section>
  );
}
